import Vue from 'vue' // alias for vue -> vue/dist/vue.js configured in webpack.config.js
import VueRouter from 'vue-router'
import QmEnvironmentConfig from '../config/qm-environment-config.js'
import VuePluginLocalForage from './lib/vue-plugin-localforage.js'
import VuePluginLogNotifier from './lib/vue-plugin-lognotifier.js'
import moment from 'moment'
import store from './store'
import VueSelect from 'vue-select'
import VueLoading from 'vue-loading-template'

// load all components used by vue-router
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Surveys from './components/Surveys.vue'
import Survey from './components/Survey.vue'
import SurveyDetail from './components/SurveyDetail.vue'
import SurveySignature from './components/SurveySignature.vue'
import ResourceList from './components/ResourceList.vue'
import Room from './components/Room.vue'
import ItemDetail from './components/ItemDetail.vue'
import Sync from './components/Sync.vue'
import Import from './components/Import.vue'
import Debug from './components/Debug.vue'

import('../node_modules/bootstrap/dist/css/bootstrap.css')
import('../node_modules/font-awesome/css/font-awesome.css')
import('../node_modules/css-ripple-effect/dist/ripple.min.css')

Vue.use(VueRouter)
Vue.use(QmEnvironmentConfig)
Vue.use(VuePluginLocalForage)
Vue.use(VuePluginLogNotifier)
Vue.use(VueLoading, { type: 'bubbles', color: '#c7c7c7', size: { width: '50px', height: '50px' } })
Vue.component('v-select', VueSelect)

require('offline-plugin/runtime').install()

const routes = [
  {
    path: '/',
    name: 'home',
    component: Surveys
  },
  {
    path: '/survey',
    name: 'survey',
    component: Survey
  },
  {
    path: '/survey-detail',
    name: 'survey-detail',
    component: SurveyDetail
  },
  {
    path: '/survey-signature',
    name: 'survey-signature',
    component: SurveySignature
  },
  {
    path: '/item-detail',
    name: 'item-detail',
    component: ItemDetail
  },
  {
    path: '/resources',
    name: 'resources',
    component: ResourceList
  },
  {
    path: '/room',
    name: 'room',
    component: Room
  },
  {
    path: '/sync',
    name: 'sync',
    component: Sync
  },
  {
    path: '/import',
    name: 'import',
    component: Import
  },
  {
    path: '/debug',
    name: 'debug',
    component: Debug
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

/**
 * define filters for mysql date time formatting in templates
 *
 * Example: {{ date | formatDate }}
 * (see components/Survey.vue)
 */
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD').format('DD.MM.YYYY')
  }
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value), 'HH:mm:ss').format('HH:mm')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(value).format('DD.MM.YYYY HH:mm')
  }
})

Vue.filter('formatFloat', function (value, decimals) {
  if (value) {
    return Number(value).toFixed(decimals)
  }
})

Vue.mixin({
  data: () => {
    return {
      get env () {
        return process.env
      }
    }
  }
})

import { mapGetters } from 'vuex'

new Vue({
  store: store,
  router: router,
  components: {
    'navbar': Navbar,
    'footerbar': Footer
  },
  computed: {
    ...mapGetters({
      session: 'getSession'
    })
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$initLog({
        url: 'https://qm-survey-api.meta.ditoy.com/logNotifier',
        consoleOutput: this.session.debug
      })
    })
  }
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js